/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimagebutton2Inputs */

const en_aiimagebutton2 = /** @type {(inputs: Aiimagebutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI image`)
};

const de_aiimagebutton2 = /** @type {(inputs: Aiimagebutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Bild`)
};

/**
* | output |
* | --- |
* | "AI image" |
*
* @param {Aiimagebutton2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimagebutton2 = /** @type {((inputs?: Aiimagebutton2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimagebutton2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimagebutton2(inputs)
	return de_aiimagebutton2(inputs)
});
export { aiimagebutton2 as "aiImageButton" }